import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { progressSelectorFactory } from 'src/common/store/selectors/loadingProgressSelector';
import { RootState } from '../../../../reducers';
import { selectPrevNextRoutePaths } from '../store/routeSelectors';
import { selectId, selectSuperSimplifierDetailsValues, selectUsiFundInfo } from '../store/selectors';
import { OnboardActionTypes, saveSuperSimplifierDetailsValues, fetchUsiFundInformation } from '../store/thunks';
import { SuperSimplifier } from './components/superSimplifier';

const mapStateToProps = (state: RootState, routeComponentProps: RouteComponentProps) => ({
  id: selectId(state),
  prevNextRoutePaths: selectPrevNextRoutePaths(state, routeComponentProps.location.pathname),
  superSimplifierDetailsValues: selectSuperSimplifierDetailsValues(state),
  saveProgress: progressSelectorFactory([OnboardActionTypes.SaveOnboarding])(state),
  usiFundNameInformation: selectUsiFundInfo(state),
  fetchUsiFundInformationProgress: progressSelectorFactory([OnboardActionTypes.FetchUsiFundInformation])(state)
});

const mapDispatchToProps = {
  saveSuperSimplifierDetailsValues,
  fetchUsiFundInformation
};

interface MatchParams {
  id?: string;
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector> & RouteComponentProps<MatchParams>;
export const SuperSimplifierContainer = connect(mapStateToProps, mapDispatchToProps)(SuperSimplifier);
